(function () {
  function formatProductCount(count) {
    return `${count} ${count === 1 ? "product" : "products"}`;
  }

  function replaceFacetCount(labelWrapper, count) {
    const textEl = labelWrapper.querySelector(".tag__text");
    if (!textEl) {
      return;
    }

    const countWrapper = textEl.parentElement;
    if (!countWrapper) {
      return;
    }

    countWrapper.innerHTML = "";
    countWrapper.appendChild(textEl);
    countWrapper.append(` (${count})`);
  }

  function stripFacetCount(labelWrapper) {
    const textEl = labelWrapper.querySelector(".tag__text");
    if (!textEl) {
      return;
    }

    const countWrapper = textEl.parentElement;
    if (!countWrapper) {
      return;
    }

    countWrapper.innerHTML = "";
    countWrapper.appendChild(textEl);
  }

  function applyAvailabilityFilterFixes() {
    const searchParams = new URLSearchParams(window.location.search);
    const availabilityFilters = searchParams.getAll("filter.v.availability");
    const inStockFilterActive =
      availabilityFilters.length === 1 && availabilityFilters[0] === "1";
    const outOfStockFilterActive =
      availabilityFilters.length === 1 && availabilityFilters[0] === "0";

    const ajaxContent = document.getElementById("CollectionAjaxContent");
    if (!ajaxContent) {
      return;
    }

    const soldOutLabel =
      (window.theme &&
        window.theme.strings &&
        window.theme.strings.soldOut &&
        window.theme.strings.soldOut.toLowerCase()) ||
      "sold out";

    const gridItems = Array.from(
      ajaxContent.querySelectorAll(".grid-item.grid-product")
    );

    const soldOutItems = gridItems.filter((item) =>
      Array.from(item.querySelectorAll(".grid-product__tag")).some(
        (tag) => tag.textContent.trim().toLowerCase() === soldOutLabel
      )
    );

    const inStockItems = gridItems.filter(
      (item) => !soldOutItems.includes(item)
    );

    if (inStockFilterActive) {
      soldOutItems.forEach((item) => item.remove());
    } else if (outOfStockFilterActive) {
      inStockItems.forEach((item) => item.remove());
    }

    const visibleItems = Array.from(
      ajaxContent.querySelectorAll(".grid-item.grid-product")
    );
    const visibleCount = visibleItems.length;
    const visibleSoldOutCount = visibleItems.filter((item) =>
      Array.from(item.querySelectorAll(".grid-product__tag")).some(
        (tag) => tag.textContent.trim().toLowerCase() === soldOutLabel
      )
    ).length;
    const visibleInStockCount = Math.max(visibleCount - visibleSoldOutCount, 0);
    const effectiveInStockCount = inStockFilterActive
      ? visibleCount
      : outOfStockFilterActive
      ? 0
      : visibleInStockCount;
    const effectiveOutOfStockCount = inStockFilterActive
      ? 0
      : outOfStockFilterActive
      ? visibleCount
      : visibleSoldOutCount;

    if (inStockFilterActive || outOfStockFilterActive) {
      document
        .querySelectorAll(
          ".collection-filter__item--count, [data-collection-count]"
        )
        .forEach((el) => {
          el.textContent = formatProductCount(visibleCount);
        });
    }

    [
      document.getElementById("CollectionSidebar"),
      document.getElementById("CollectionInlineFilterWrap"),
    ]
      .filter(Boolean)
      .forEach((root) => {
        root.querySelectorAll(".tag__checkbox-wrapper").forEach((labelWrapper) => {
          const input = labelWrapper.querySelector(".tag__input");
          if (!input) {
            return;
          }

          if (input.name === "filter.v.availability") {
            replaceFacetCount(
              labelWrapper,
              input.value === "1"
                ? effectiveInStockCount
                : effectiveOutOfStockCount
            );
            return;
          }

          if (inStockFilterActive || outOfStockFilterActive) {
            stripFacetCount(labelWrapper);
          }
        });
      });
  }

  function applyWholesaleCollectionSidebarFixes() {
    const wholesaleSidebar = document.querySelector(
      "#CollectionSidebar[data-wcp-wholesale-customer='true']"
    );

    if (!wholesaleSidebar) {
      return;
    }

    const roots = [
      wholesaleSidebar,
      document.getElementById("CollectionInlineFilterWrap"),
    ].filter(Boolean);

    roots.forEach((root) => {
      root.querySelectorAll(".price-range").forEach((priceRange) => {
        const group = priceRange.closest("[class*='collection-sidebar__group--']");
        if (group) {
          group.style.display = "none";
        }
      });

      root
        .querySelectorAll("input[name='filter.v.availability']")
        .forEach((availabilityInput) => {
          const group = availabilityInput.closest(
            "[class*='collection-sidebar__group--']"
          );
          if (group) {
            group.style.display = "none";
          }
        });

      root.querySelectorAll(".tag__text").forEach((textEl) => {
        const labelWrapper = textEl.parentElement;
        if (!labelWrapper) {
          return;
        }

        Array.from(labelWrapper.childNodes).forEach((node) => {
          if (
            node.nodeType === Node.TEXT_NODE &&
            /\(\s*\d+\s*\)/.test(node.textContent || "")
          ) {
            node.textContent = "";
          }
        });
      });
    });
  }

  const isDesktop = window.innerWidth > 768;

  if (isDesktop) {
    const headerHeight = document.getElementById("HeaderWrapper")?.offsetHeight;
    const offSet = headerHeight ? Number(headerHeight) : "180";

    const subCollectionsWrapper = document.getElementById("subCollections");

    if (subCollectionsWrapper) {
      subCollectionsWrapper.style.top = `${offSet}px`;

      const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("isSticky", e.intersectionRatio < 1),
        {
          rootMargin: `-${offSet + 2}px 0px 0px 0px`,
          threshold: [1],
        }
      );

      observer.observe(subCollectionsWrapper);
    }
  }

  applyAvailabilityFilterFixes();
  applyWholesaleCollectionSidebarFixes();
  document.addEventListener(
    "collection:reloaded",
    applyAvailabilityFilterFixes
  );
  document.addEventListener(
    "collection:reloaded",
    applyWholesaleCollectionSidebarFixes
  );

  // Gift notes update
  const cartNote = document.getElementById("CartHeaderNote");
  const toNote = document.getElementById("note-to");
  const fromNote = document.getElementById("note-from");

  if (cartNote && toNote && fromNote) {
    cartNote.addEventListener("input", (event) => {
      const noteValue = event.target.value;
      if (
        noteValue &&
        noteValue !== "" &&
        toNote.value !== "" &&
        fromNote.value !== ""
      ) {
        theme.cart.updateNote(
          `From: ${fromNote.value}. To: ${toNote.value}. Message: ${noteValue}`
        );
      } else {
        theme.cart.updateNote("");
      }
    });
  }
})();
